export default function UpdatesTab() {
  // Placeholder: Replace with real update data if available
  return (
    <div className="p-4 text-gray-500">
      <div className="mb-2 font-semibold">Recent Updates</div>
      <div>No updates available for this staff member.</div>
    </div>
  );
}
